import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { LinkLabelModule } from '@common/components/link-label/link-label.module';
import { TextWithTooltipModule } from '@common/components/text-with-tooltip/text-with-tooltip.module';
import { PassengerNameModule } from '@common/pipes';
import { TooltipDirectiveModule } from '@lib/directives';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { BaggageRulesComponent } from './baggage-rules.component';

@NgModule({
  declarations: [BaggageRulesComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    TableSliderModule,
    PassengerNameModule,
    TooltipDirectiveModule,
    AmountFormatModule,
    LinkLabelModule,
    TextWithTooltipModule,
  ],
  exports: [BaggageRulesComponent],
})
export class BaggageRulesModule {}
